import {exhaustive} from '@freckle/exhaustive'
import {fromMaybe} from '@freckle/maybe'
import {nonEmptyToArray} from '@freckle/non-empty'
import StorageHelper from '@freckle/educator-entities/ts/common/helpers/storage-helper'
import type {
  DashboardIdentityProviderT,
  AllProvidersOrSpecificT,
} from '@freckle/school/ts/common/helpers/api-helper'
import {allIdentityProviders} from '@freckle/school/ts/common/helpers/api-helper'

const idpsSelectedKey = 'idp-picker-idps-selected'

export function storeIdpsSelected(idps: Array<DashboardIdentityProviderT>) {
  StorageHelper.setLocalStorageProperty(idpsSelectedKey, idps)
}

function getIdpsSelectedFromStorage(): Array<DashboardIdentityProviderT> | null {
  return StorageHelper.getLocalStorageProperty(idpsSelectedKey) ?? null
}

export function initialSelection(
  currentIdps: AllProvidersOrSpecificT,
  idpCounts: Map<DashboardIdentityProviderT, number>,
): Array<DashboardIdentityProviderT> {
  switch (currentIdps.tag) {
    case 'all': {
      const getSelected = () => {
        const anyNonManual = allIdentityProviders().some(
          idp => idp !== 'manual' && (idpCounts.get(idp) as number) > 0,
        )
        if (anyNonManual) {
          return Array.from(idpCounts.keys()).filter(idp => idp !== 'manual')
        }
        return Array.from(idpCounts.keys())
      }
      return fromMaybe(getSelected, getIdpsSelectedFromStorage()) as DashboardIdentityProviderT[]
    }
    case 'specific':
      return nonEmptyToArray(currentIdps.specific)
    default:
      return exhaustive(currentIdps)
  }
}
